<template>
  <div>
    <div class="hover:bg-selection" :class="{'bg-selection': isOpen}">
      <ButtonModule
        ref="reference"
        text="Move to.."
        :disabled="disabled"
        :prefix="`icon-input mr-15 ${isDraculaTheme ? 'text-main-color' : 'text-app-color'}`"
        class="text-app-color p-12 w-full"
        @click.stop="toggle"
      />
    </div>
    <teleport to="body">
      <div
        v-if="isOpen"
        ref="content"
        class="absolute w-200 max-h-270 overflow-y-auto rounded-10 rounded-tl-0 shadow bg-primary text-app-color"
        :class="[isDarkMode ? 'bg-dark-800' : 'bg-white', show ? 'opacity-100' : 'opacity-0']"
        :style="`top: ${position.top}px; left: ${position.left}px;`"
      >
        <div class="font-semibold text-15 py-7 px-20 rounded-t-10">
          Spaces
        </div>
        <div
          v-for="item in filteredBooks"
          :key="item.id"
          class="truncate text-15 py-10 px-20 cursor-pointer last:mb-0 no-scroll-bar last:rounded-b-10 hover:bg-selection"
          @click="moveTo(item.id)"
        >
          {{ item.title }}
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  components: { ButtonModule },

  props: {
    project: {
      type: Object
    },
    book: {
      type: Object
    }
  },

  data () {
    return {
      isOpen: false,
      position: {
        top: 0,
        left: 0
      },
      show: false
    }
  },

  computed: {
    ...mapState({
      books: state => state.book.books,
      currentProject: state => state.project.currentProject,
      team: state => state.team.team
    }),

    ...mapGetters(['isDarkMode', 'isDraculaTheme']),

    filteredBooks () {
      return this.books.filter(item => item.id !== this.project.bookId && !item.isSection)
    },

    disabled () {
      const projects = this.book.projects.filter(item => !item.parentId)

      if (this.filteredBooks.length === 0) {
        return true
      } else if (this.book.projects.length === 1) {
        return true
      } else {
        if (this.project.parentId) {
          return false
        }
      }

      return projects.length === 1
    }
  },

  methods: {
    ...mapActions(['editProject', 'getBook']),

    toggle () {
      this.isOpen = !this.isOpen
      if (this.isOpen) this.setPosition()
    },

    setPosition () {
      setTimeout(() => {
        const rect = this.$refs.reference.$el.getBoundingClientRect()
        const contentHeight = this.$refs.content.getBoundingClientRect().height

        if (window.innerHeight - rect.top < contentHeight) {
          this.position = {
            top: window.innerHeight - contentHeight,
            left: rect.right + 1
          }
        } else {
          this.position = {
            top: rect.top,
            left: rect.right + 1
          }
        }

        this.show = true
      }, 100)
    },

    moveTo (id) {
      if (this.project.subProject?.length) {
        const arr = []

        this.project.subProject.forEach(item => {
          arr.push(this.editProject({
            id: item.id,
            data: {
              title: item.title,
              bookId: id
            }
          }))
        })

        Promise.all(arr).then(() => {
          this.edit(id)
        })
      } else {
        this.edit(id)
      }
      this.isOpen = false
    },

    edit (id) {
      this.editProject({
        id: this.project.id,
        data: {
          title: this.project.title,
          parentId: null,
          bookId: id
        }
      }).then(() => {
        this.getBook(this.$route.params.id).then((book) => {
          this.$router.replace({ query: { page: book.projects[0]?.id } })
        })
      })
    }
  }
}
</script>
